<script setup lang="ts">
import { inject } from 'vue'

const props = defineProps<{
  placeholder?: string
}>()

const { modelValue } = inject('select', {
  modelValue: { value: undefined }
})
</script>

<template>
  <span :class="{ 'text-muted-foreground': !modelValue.value }">
    <slot>{{ modelValue.value || props.placeholder }}</slot>
  </span>
</template>
